import { render, staticRenderFns } from "./CadastroLayoutArquivoRetorno.vue?vue&type=template&id=d12486b4&scoped=true&"
import script from "./CadastroLayoutArquivoRetorno.vue?vue&type=script&lang=js&"
export * from "./CadastroLayoutArquivoRetorno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12486b4",
  null
  
)

export default component.exports